export default "__VITE_ASSET__2b0345bb__"